import React, { Component } from 'react';

import { connect } from 'react-redux';

import { openDrawer, closeDrawer } from 'actions/drawer';
import { addNotification } from 'actions/notifications';

import { PanelSection, PanelSectionWithLabel } from 'components/PanelSections';

import { Classroom } from 'models';
import { validate } from 'models/validate';


import { VisibleOnlyAdmin } from 'components/AuthenticatedComponent';
import ContentHeader from 'components/ContentHeader';
import ContentFooter from 'components/ContentFooter';
import Input from './Input';
import StudentPanelList from 'components/StudentPanelList';

import { keyedObjToArr, setObjPath, formatValue } from '../util';

class ClassroomPanel extends Component {

	constructor (props) {
		super(props);
		let classroom = this.props.classroom || {};
		this.state = {
			classroom : classroom
		};
	}

	updateClassroom (event) {
		let value = formatValue(event.target.value, event.target.type);
		let classroom = setObjPath(this.state.classroom, event.target.name, value);
		this.setState({
			classroom : classroom
		});
	}

	updateClassroomTeacher (option) {
		let classroom = this.state.classroom;
		classroom.teacher = option.value;

		this.setState({
			classroom : classroom
		});
	}

	updateClassroomSchool (option) {
		let classroom = this.state.classroom;
		classroom.school = option.value;

		this.setState({
			classroom : classroom
		});
	}

	updateClassroomProduct (option) {
		let classroom = this.state.classroom;
		classroom.product = option.value;

		this.setState({
			classroom : classroom
		});
	}

	updateClassroomStudents (students) {
		if(this.state.classroom.studentCount && Object.keys(students).length < this.state.classroom.studentCount) {

			let classroom = this.state.classroom;
			classroom.students = students;
			this.setState({
				classroom : classroom
			});
			console.log('add and dont show notification');
		} else {
			console.log('too many students');
			this.props.addNotification('update-classroom-students-error-' + Date.now(), 'You have reached the limit of students for this classroom');
		}
	}

	toggleClassroomDisabled (event) {
		let classroom = this.state.classroom;

		if(event.target.checked) {
			classroom.disabled = true;
		} else {
			classroom.disabled = false;
		}
		this.setState({
			classroom : classroom
		});
	}

	render () {

		let teacherOptions = [];
		keyedObjToArr(this.props.users).forEach( (user) => {
			if(!user.disabled) {
                teacherOptions.push({
                    label: `${user.name} - ${user.email}`,
                    value: user.id
                });
            }
		});

		let schoolOptions = keyedObjToArr(this.props.schools).map( (school) => {
			return {
				label : school.name,
				value : school.id
			};
		});

        let schoolName= '';
		if(this.state.classroom.school && this.state.classroom.school in this.props.schools){
            schoolName = this.props.schools[this.state.classroom.school].name;
		}

		let productOptions = keyedObjToArr(this.props.products).map( (product)=> {
			let productName = product.name;
			if(!product.active)
				productName += ' (inactive)';

			return {
				label : productName,
				value : product.productId
			};
		});

		let classroomProduct = keyedObjToArr(this.props.products).find( (productItem) => {
			return productItem.productId === this.state.classroom.product;
        });
		let classroomTeacher = this.props.users[this.state.classroom.teacher];

		return (<div className="panel">
			<ContentHeader
					title={this.props.editing ? 'Editing ' + this.props.classroom.name : 'Create New Classroom'}
					closeable="true"
					onClose={this.props.closeDrawer}
				/>
				<div className="panel-content">
					<div className="container">

					{/* Classroom Name */}
					<PanelSectionWithLabel label="Name" header="Classroom Info">
						<Input
							value={this.state.classroom.name}
							placeholder="Classroom Name"
							name="name"
							onChange={this.updateClassroom.bind(this)}
						/>
					</PanelSectionWithLabel>

					{/* Classroom School */}
					<VisibleOnlyAdmin>
						<PanelSectionWithLabel label="School">
							{ this.props.user && this.props.user.role === 'admin' ? (
								<Input
									type="typeahead"
									placeholder="School"
									name="school"
									value={this.state.classroom.school}
									onChange={this.updateClassroomSchool.bind(this)}
									options={schoolOptions}
									sortOptions={true}
								/>
							) : (
								<span>{schoolName}</span>
							)}
						</PanelSectionWithLabel>
					</VisibleOnlyAdmin>

					{/* Classroom Teacher */}
					<VisibleOnlyAdmin>
						<PanelSectionWithLabel label="Teacher">
							{ this.props.user && this.props.user.role === 'admin' ? (
								<Input
									type="typeahead"
									placeholder="Teacher"
									name="teacher"
									value={this.state.classroom.teacher}
									onChange={this.updateClassroomTeacher.bind(this)}
									options={teacherOptions}
									sortOptions={true}
								/>
							) : (
								<span>{classroomTeacher ? classroomTeacher.email : false}</span>
							)}
						</PanelSectionWithLabel>
					</VisibleOnlyAdmin>

					{/* Classroom Products */}
					<PanelSectionWithLabel label="Product">
					{ this.props.user && this.props.user.role === 'admin' && !this.props.editing ? (
						<Input
							type="typeahead"
							placeholder="Product"
							name="product"
							value={this.state.classroom.product}
							onChange={this.updateClassroomProduct.bind(this)}
							options={productOptions}
                            sortOptions={false}
						/>
						):(
							<span>{classroomProduct ? classroomProduct.name : false}</span>
						)}
					</PanelSectionWithLabel>

					{/* Classroom Student Count */}
					<PanelSectionWithLabel label="Students">
						{ this.props.user && this.props.user.role === 'admin' ? (
							<Input
								value={this.state.classroom.studentCount}
								placeholder="Number of Students"
								name="studentCount"
								type="number"
								onChange={this.updateClassroom.bind(this)}
							/>
						):(
							<span>{this.state.classroom.studentCount}</span>
						)}
					</PanelSectionWithLabel>

					{/* Classroom Disabled */}
					<VisibleOnlyAdmin>
					<PanelSectionWithLabel label="Disabled">
						<Input
							type="toggle"
							name="disabled"
							checked={this.state.classroom.disabled}
							value={this.state.classroom.disabled}
							offLabel="Off"
							onLabel="On"
							onChange={this.toggleClassroomDisabled.bind(this)}
						/>
					</PanelSectionWithLabel>
					</VisibleOnlyAdmin>

					{/* Classroom Student List */}
					<PanelSection className="panel-section" label="Name" header="Students">
						<StudentPanelList
							classroom={this.state.classroom}
							updateClassroomStudents={this.updateClassroomStudents.bind(this)}
						/>
					</PanelSection>

					</div>
				</div>
				<ContentFooter
					onClose={this.props.closeDrawer}
					onCancel={this.props.onCancel}
					confirmLabel="Save Classroom"
					onConfirm={function () {
						validate(this.state.classroom, Classroom).then( (validatedClassroom) => {
							if(this.props.editing) {
								this.props.saveClassroom(validatedClassroom);
								this.props.addNotification('add-save-classroom-success-' + Date.now(), 'Classroom Saved');
							} else {
								this.props.addClassroom(validatedClassroom);
								this.props.addNotification('add-save-classroom-success-' + Date.now(), 'Classroom Added');
								this.props.closeDrawer();
							}

						}).catch( (error)=> {
							console.log(error.message);
							this.props.addNotification('add-save-classroom-error-' + Date.now(), error.message);
						});


					}.bind(this)}
				/>

		</div>);
	}
}

const mapStateToProps = (state) => {
	return { user : state.user };
};

const mapDispatchToProps = (dispatch) => {
	return {
		openDrawer :  (panel) => { dispatch(openDrawer(panel)); },
		closeDrawer : () => { dispatch(closeDrawer()); },
		addNotification : (key, message) => { dispatch(addNotification(key, message)); }
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ClassroomPanel);




// WEBPACK FOOTER //
// ./js/components/ClassroomPanel.js